var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{class:_vm.cls,style:({fontSize: _vm.fontSize, color: _vm.color, textAlign: _vm.textAlign, fontWeight: _vm.fontWeight }),attrs:{"scope":"col"}},[_vm._v(" "+_vm._s(_vm.text)),(_vm.subText)?_c('span',{style:({ fontSize: _vm.subFontSize, fontWeight: 450 })},[_vm._v(_vm._s(_vm.subText))]):_vm._e(),_vm._t("sub-item")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }